"use client";

import { sendGAEvent } from '@next/third-parties/google'

const sponsorInfo = {
    name: "Get 3x More Responses to your Job Applications",
    image: 'https://img.headshotgrapher.com/emanuel_2.png',
    link: 'https://headshotgrapher.com/?utm_source=realworkfromanywhere.com&utm_medium=sponsor&utm_campaign=job_conversion',
    description: "With Professional Headshots, upload 6-7 photos and get your headshots in just 3 minutes",
    cta: 'Get Headshots',
    badge: '3x Results',
}

const SponsorAvatar = ({ image }) => (
    <div className="avatar relative">
        {image ? (
            <div className="w-16 rounded-full bg-white border-2 shadow-lg hover:scale-105 transition-transform duration-300">
                <img src={image} alt="Sponsor logo" loading="lazy" />
            </div>
        ) : (
            <div className="avatar placeholder">
                <div className="text-neutral-content rounded-full w-16 text-center bg-gray-600">
                    <span className="text-xs">Your Product logo</span>
                </div>
            </div>
        )}
    </div>
);

const SponsorContent = ({ name, description, badge }) => (
    <div className="sm:-ml-8">
        <div className="flex flex-row items-center gap-2">
            <div className="text-white antialiased font-bold">{name}</div>
            {badge && (
                <div className="hidden sm:inline px-2 py-0.5 bg-white text-sky-600 text-xs font-bold rounded-md">
                    {badge}
                </div>
            )}
        </div>
        <div className="text-white antialiased font-medium">{description}</div>
    </div>
);

const SponsorCTA = ({ cta, onClick }) => (
    <button
        onClick={onClick}
        className="ml-auto btn bg-white text-black border-0  font-bold shadow-md antialiased hover:scale-105 transition-all duration-200"
        aria-label={`Click to ${cta}`}
    >
        {cta}
        <span className="inline-block translate-x-0 group-hover:translate-x-1 transition-transform ease-in-out duration-200">
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth="1.5" 
                stroke="currentColor" 
                className="mt-0.5 h-6 w-6"
                aria-hidden="true"
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
            </svg>
        </span>
    </button>
);

const Sponsor2 = () => { 
    const handleClick = () => {
        if (sponsorInfo.link) {
            window.open(sponsorInfo.link, '_blank', 'noopener,noreferrer');

            sendGAEvent('event', 'headshotgrapher_click', { 
                value: sponsorInfo.name,
                conversion: true
            })
        }
    };

    const handleCTAClick = (e) => {
        e.stopPropagation();
        handleClick();
    };

    return (
        <div className="flex flex-col m-auto mt-2 w-full sm:w-[85%]">
            <div
                role="button"
                tabIndex={0}
                className="group flex flex-col ring-1 ring-inset ring-gray-500/20 rounded-md bg-cyan-700 hover:bg-opacity-90 cursor-pointer shadow-lg transition-all duration-300"
                onClick={handleClick}
                onKeyDown={(e) => e.key === 'Enter' && handleClick()}
                aria-label={`Visit ${sponsorInfo.name}`}
            >
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-12 sm:items-center p-3 sm:p-5">
                    <SponsorAvatar image={sponsorInfo.image} />
                    <SponsorContent 
                        name={sponsorInfo.name} 
                        description={sponsorInfo.description}
                        badge={sponsorInfo.badge}
                    />
                    <div className='ml-auto flex gap-2 items-center'>
                        <p className="text-zinc-300 text-xs">Ad</p>
                        <SponsorCTA cta={sponsorInfo.cta} onClick={handleCTAClick} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sponsor2;